export function SegmentationVolume({
  volumeMm3,
  voxelCount,
}: {
  volumeMm3?: number | null;
  voxelCount?: number | null;
}) {
  const volume =
    volumeMm3 != null && Number.isFinite(volumeMm3) && volumeMm3 >= 0
      ? (volumeMm3 / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 })
      : "—";
  const voxels =
    voxelCount != null && Number.isInteger(voxelCount) && voxelCount >= 0
      ? voxelCount.toLocaleString("en-US")
      : "—";
  return (
    <div className="font-mono text-[11px] text-fg-muted">
      Volume {volume} cm³ ({voxels} voxels)
    </div>
  );
}
